<div class="filter bg-default-inverse-color" [ngClass]="toggled ? 'active' : ''" (click)="buttonClicked()">
    <span class="name">{{name}}</span>
</div>
